import { general_File_str } from '@zenlayer/zen-design-icons';
import classNames from 'classnames';
import React from 'react';
import { pickDomAttrs } from '../_util/utils';
import Badge from '../badge';
import Button from '../button';
import { useConfig } from '../hooks/useConfig';
import Icon from '../icon';
import SvgIcon from '../svg-icon';
import Space from '../space';
import bgIcon from './bg';
import './style/index';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const LandingPage = props => {
  var _features$list;
  const {
    icon,
    title,
    whatIsUrl,
    desc,
    additional,
    action,
    freeRibbon,
    features,
    middleContent,
    reason,
    extraContent,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-landingPage");
  const attrs = pickDomAttrs(restProps);
  const isDataType = reason => {
    return reason && (reason.title !== undefined || reason.list !== undefined);
  };
  const {
    locale: {
      Layout: LayoutLocale
    }
  } = useConfig();
  const showUpperPart = icon || title || desc || additional || features || freeRibbon;
  const whatIsDom = whatIsUrl && /*#__PURE__*/_jsx(Button, {
    icon: /*#__PURE__*/_jsx(SvgIcon, {
      svgStr: general_File_str
    }),
    size: "s",
    type: "text",
    className: "whatIsButton",
    onClick: () => {
      window.open(whatIsUrl);
    },
    children: LayoutLocale.layout_basic_header_whatIs
  });
  const renderReason = () => {
    if (isDataType(reason)) {
      return /*#__PURE__*/_jsxs("div", {
        className: "reason",
        children: [reason.title && /*#__PURE__*/_jsx("div", {
          className: "reason-title",
          children: reason.title
        }), reason.list && /*#__PURE__*/_jsx("div", {
          className: "reason-list",
          children: reason.list.map((i, k) => /*#__PURE__*/_jsxs(Space, {
            direction: "vertical",
            className: "reason-list-item",
            children: [/*#__PURE__*/_jsx("span", {
              className: "reason-list-item-label",
              children: i.label
            }), /*#__PURE__*/_jsx("span", {
              className: "reason-list-item-text",
              children: i.text
            })]
          }, k))
        })]
      });
    }
    return /*#__PURE__*/_jsx(_Fragment, {
      children: reason
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    ...attrs.data,
    className: classNames(baseClassName, className),
    style: style,
    children: [/*#__PURE__*/_jsx(Icon.CustomIcon, {
      component: bgIcon,
      className: "bgIcon"
    }), /*#__PURE__*/_jsxs("div", {
      className: "content",
      children: [showUpperPart && /*#__PURE__*/_jsxs("div", {
        className: "upperPart",
        children: [/*#__PURE__*/_jsxs(Space, {
          direction: "vertical",
          size: "lll",
          className: "main",
          children: [/*#__PURE__*/React.isValidElement(icon) && /*#__PURE__*/React.cloneElement(icon, {
            fontSize: 52
          }), /*#__PURE__*/_jsxs("div", {
            className: "title",
            children: [title, whatIsDom]
          }), /*#__PURE__*/_jsx("span", {
            className: "desc",
            children: desc
          }), additional && /*#__PURE__*/_jsx("div", {
            className: "additional",
            children: additional
          }), action && /*#__PURE__*/_jsx("div", {
            className: "action",
            children: action
          })]
        }), features && /*#__PURE__*/_jsx("div", {
          className: "features-box",
          children: /*#__PURE__*/_jsx(Badge, {
            className: "features-ribbon",
            type: "ribbon",
            ribbonDirection: "down",
            text: freeRibbon,
            ribbonTop: 24,
            children: /*#__PURE__*/_jsxs("div", {
              className: "features",
              children: [features.title && /*#__PURE__*/_jsx("span", {
                className: "features-title",
                children: features.title
              }), features === null || features === void 0 || (_features$list = features.list) === null || _features$list === void 0 ? void 0 : _features$list.map((i, k) => /*#__PURE__*/_jsxs("div", {
                className: "features-list-item",
                children: [/*#__PURE__*/_jsx("div", {
                  className: "my-point"
                }), i]
              }, k)), features.action && /*#__PURE__*/_jsx("div", {
                className: "features-action",
                children: features.action
              })]
            })
          })
        })]
      }), middleContent, renderReason(), extraContent]
    })]
  });
};
export default LandingPage;